import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { AgentCommissionPaymentForm } from '../form-template/agent-commission-payment-form';
import { AgentCommissionPaymentItemForm } from '../form-template/agent-commission-payment-item-form';
import * as moment from 'moment';
import { AgentCommissionPayment } from '../agent-commission-payment';
import { SelectItem} from 'primeng/api';

import { AgentCommissionPaymentItem } from '../agent-commission-payment-item';

import Decimal from 'decimal.js';

@Component({
  selector: 'app-agent-commission-create-payment',
  templateUrl: './agent-commission-create-payment.component.html',
  styleUrls: ['./agent-commission-create-payment.component.css']
})
export class AgentCommissionCreatePaymentComponent {

  bookingIds: number[] = [];
  rootForm: FormGroup<AgentCommissionPaymentForm>;
  bookingIdItems: SelectItem[] = [];
  totalAmount: string = "0";

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService
  ) {
    this.rootForm = new FormGroup<AgentCommissionPaymentForm>({
      date: new FormControl<Date | null>(new Date()),
      items: builder.array([]) as FormArray
    });
    httpService.getAgentCommissionAvailableBookingIds().subscribe(res => {
      this.bookingIds = res;
      this.bookingIdItems = [];
      for(let id of res){
        this.bookingIdItems.push({label: id.toString(), value: id});
      }
    });
  }

  addForm() {
    this.bookingFormArray.push(new FormGroup<AgentCommissionPaymentItemForm>({
      bookingId: new FormControl<number | null>(null),
      amount: new FormControl<number | null>(null)
    }));
  }

  get bookingFormArray(): FormArray {
    return this.rootForm.controls.items as FormArray;
  }

  submitForm() {
    console.log(this.rootForm);
    let date = moment(this.rootForm.value.date);
    let commissionPayment: AgentCommissionPayment = {
      date: date.utc(true),
      items: []
    };
    for (let control of this.bookingFormArray.controls) {
      commissionPayment.items.push(<AgentCommissionPaymentItem>{
        bookingId: control.value.bookingId.value,
        amount: new Decimal(control.value.amount)
      });
    }

    this.httpService.postAgentCommissionPayment(commissionPayment).subscribe(() => {
      console.log("success");
    });
  }

  amountChange(){
    let total = new Decimal(0);
    for (let control of this.bookingFormArray.controls) {
      if(control.value.amount){
        total = total.add(new Decimal(control.value.amount));
      }
    }
    this.totalAmount = total.toFixed(2);
  }

  deleteBookingForm(i: number){
    console.log(i);
    this.bookingFormArray.removeAt(i);
  }

}
